import AuthLayout from "./views/AuthLayout";
// import Success from './components/Success'
import Verify from "./components/Verify";
import ForgotPassword from "./components/ForgotPassword";
import ActivationCancel from "../activation/components/ActivationCancel";
import RequestCredentials from "./components/RequestCredentials";
import Landing from "../landing/views/landing";
import SetPassword from "./components/SetPassword";

export default [
  {
    path: "/auth",
    name: "Auth",
    component: AuthLayout,
    children: [
      {
        path: "forgot-password",
        name: "forgotPassword",
        component: ForgotPassword,
      },
      {
        path: "sign-in",
        name: "SignIn",
        component: Landing,
      },
      {
        path: "set-password/:token",
        name: "setPassword",
        component: SetPassword,
      },
      {
        path: "verify/:code",
        name: "verify",
        component: Verify,
      },
      {
        path: "/activation/cancelactivation/:code",
        component: ActivationCancel,
        name: "ActivationCancel",
      },
      {
        path: "request-credentials",
        component: RequestCredentials,
        name: "RequestCredentials",
      },
    ],
  },
];
